export default "__VITE_ASSET__05yYb$Ar__"